import { Copy04 as CopyIcon } from "@hl/base-components/lib/assets/icons.generated";
import {
  CLEAR_COLOR,
  SECONDARY_COLOR,
} from "@hl/base-components/lib/theme/button";
import {
  Stack,
  TextInput,
  Button,
  CopyButton,
  ActionIcon,
} from "@mantine/core";
import { usePrivy } from "@privy-io/react-auth";
export const WalletSettings = ({
  active,
  walletAddresses,
}: {
  active?: boolean;
  walletAddresses?: string[] | null;
}) => {
  const { ready, authenticated, user, exportWallet } = usePrivy();
  const isAuthenticated = ready && authenticated;
  const hasEmbeddedWallet = !!user?.linkedAccounts.find(
    (account) =>
      account.type === "wallet" && account.walletClientType === "privy"
  );
  if (!active) return null;

  const walletAddress = walletAddresses?.[0] || "";
  return (
    <Stack spacing={40} maw={640}>
      <TextInput
        label="Wallet address"
        value={walletAddress}
        disabled={true}
        rightSection={
          <CopyButton value={walletAddress}>
            {({ copy }) => (
              <ActionIcon
                size="xs"
                color={CLEAR_COLOR}
                onClick={(e) => {
                  copy();
                  e.preventDefault();
                }}
              >
                <CopyIcon height={14} width={14} />
              </ActionIcon>
            )}
          </CopyButton>
        }
      />
      {hasEmbeddedWallet && isAuthenticated && (
        <TextInput
          label="Wallet private key"
          value={"••••••••••••••••••••••••••••••••"}
          disabled={true}
          rightSection={
            <Button color={SECONDARY_COLOR} size="xs" onClick={exportWallet}>
              Export
            </Button>
          }
        />
      )}
    </Stack>
  );
};
